<template>
  <input
    :id="id"
    :checked="value"
    class="input-switch"
    :type="type"
    :name="name"
    :disabled="disabled"
    @input="select($event.target.value)"
  />
</template>

<script>
export default {
  name: 'AtomSwitchInput',
  props: {
    id: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'checkbox',
    },
    name: {
      type: String,
      default: '',
    },
  },
  emits: ['select'],
  methods: {
    select() {
      this.$emit('select', !this.value)
    },
  },
}
</script>

<style lang="postcss" scoped>
[type='checkbox']:checked,
[type='checkbox']:not(:checked),
[type='radio']:checked,
[type='radio']:not(:checked) {
  position: absolute;
  left: -9999px;
}
</style>
